import { Icon } from "../Icon/icon";
import { LoadingOval } from "../loaders/loaders";

export const Button = ({
  text,
  onClick,
  type = "submit",
  className = "",
  loading = false,
  disabled = false,
  icon = "",
  iconClassName = "",
  variation = "primary",
  loaderWidth = "25",
  loaderHeight = "25",
  iconDimension = 16,
  extra,
}) => {
  const getColors = () => {
    switch (variation) {
      case "primary":
        return "bg-primary border-primary text-white";
      case "deep-primary":
        return "bg-deep-primary border-deep-primary text-white";
      case "dark-grey":
        return "bg-grey-900 border-grey-900 text-white";
      case "white":
        return "bg-white border-white text-deep-primary";
      case "grey":
        return "bg-grey-50 border-grey-50 text-primary";
      case "danger":
        return "bg-danger border-danger text-white";
      case "green-outline":
        return "bg-transparent border-success text-success";
      case "bland":
        return "bg-transparent border-transparent text-grey-950";
      default:
        break;
    }
  };

  const getLoaderColors = () => {
    switch (variation) {
      case "primary":
        return "#ffffff";
      case "plain":
        return "#04000A";
      default:
        return "#04000A";
    }
  };

  return (
    <button
      type={type}
      onClick={(e) => {
        if (onClick) {
          if (type !== "submit") {
            e.preventDefault();
          }
          onClick();
        }
      }}
      disabled={disabled || loading}
      className={` ${getColors()} soft-shrink relative flex w-full items-center justify-center gap-[8px] rounded-[8px] border px-3 md:px-4 py-3 text-xs md:text-sm font-bold disabled:cursor-not-allowed disabled:opacity-100 disabled:hover:scale-100 ${
        loading && "!text-transparent"
      } ${className} `}
    >
      {icon && (
        <Icon
          svg={icon}
          width={iconDimension}
          height={iconDimension}
          className={iconClassName}
        />
      )}
      {text}
      {extra ?? extra}
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center">
          <LoadingOval
            loaderHeight={loaderHeight}
            loaderWidth={loaderWidth}
            color={getLoaderColors()}
          />
        </div>
      )}
    </button>
  );
};
